import { render, staticRenderFns } from "./EmsMonitor.vue?vue&type=template&id=384052d8&scoped=true"
import script from "./EmsMonitor.vue?vue&type=script&lang=js"
export * from "./EmsMonitor.vue?vue&type=script&lang=js"
import style0 from "./EmsMonitor.vue?vue&type=style&index=0&id=384052d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384052d8",
  null
  
)

export default component.exports